'use client';

import { ReactNode, createContext, useContext, useState } from 'react';
import { UserInfo } from '../../types/user.types';
import { noop } from 'lodash';
import useBrowserStorage from '../../hooks/use-browser-storage';
import { ToastInfo, ToastType } from '../../types/common.types';

interface CommonContextProps {
  userInfo: UserInfo | null,
  setUserInfo: (userInfo: UserInfo | null) => void;
  toastInfo: ToastInfo | null;
  setToastInfo: (val: ToastInfo) => void;
}

const contextInitialValues: CommonContextProps = {
  userInfo: null,
  setUserInfo: noop,
  toastInfo: {
    isOpen: false,
    type: ToastType.SUCCESS,
    message: '',
  },
  setToastInfo: noop,
};

type Props = {
  children: ReactNode;
};
export const ModelNameContext =
  createContext<CommonContextProps>(contextInitialValues);

export function useAppContext() {
  return useContext(ModelNameContext);
}

export const AppContextProvider: React.FC<Props> = ({ children }) => {
  const { getItem } = useBrowserStorage();
  const userData = JSON.parse(getItem('userInfo', 'local') || 'null');
  const [userInfo, setUserInfo] = useState<UserInfo | null>(userData ? userData : null);
  const [toastInfo, setToastInfo] = useState<ToastInfo | null>(null);

  const value = {
    userInfo,
    setUserInfo,
    toastInfo,
    setToastInfo,
  };
  return (
    <ModelNameContext.Provider value={value}>
      {children}
    </ModelNameContext.Provider>
  );
};
